module.exports = __webpack_public_path__ + "img/cns_printer_mac32.55b3da8c.png";